// extracted by mini-css-extract-plugin
export var integrationButton = "_97-0";